import React, { useState, useEffect } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";

const OnboardingSection = () => {
  const [stepIndex, setStepIndex] = useState(0);
  const [expandedSections, setExpandedSections] = useState({
    0: true,
    2: false,
    4: false,
  });

  const steps = [
    {
      title: "Welcome",
      image: "/assets/guide/front_page.png",
      level: 0,
      description:
        "Welcome to OSRS Snakes & Ladders! This guide will help you get set up.",
    },
    {
      title: "Discord Auth",
      image: "/assets/guide/auth/onboarding/discord_oauth.png",
      level: 0,
      description: "Sign in using your Discord account.",
    },
    {
      title: "Register Characters",
      image: "/assets/guide/auth/onboarding/onboarding_step1_osrs_ign.png",
      level: 0,
      id: 2,
      description: "Enter your OSRS In-Game Name(s).",
    },
    {
      title: "IGN Filled",
      image:
        "/assets/guide/auth/onboarding/onboarding_step1_osrs_ign_filled.png",
      level: 1,
      parentId: 2,
      description:
        "Once you've entered your character names, click the link button.",
    },
    {
      title: "Clan Selection",
      image: "/assets/guide/auth/onboarding/onboarding_step2_clan_skip.png",
      level: 0,
      id: 4,
      description: "Choose your participation level.",
    },
    {
      title: "Clan: Owner",
      image: "/assets/guide/auth/onboarding/onboarding_step2_clan_owner.png",
      level: 1,
      parentId: 4,
      description: "Select this if you are starting a new clan.",
    },
    {
      title: "Clan Profile Setup",
      image:
        "/assets/guide/auth/onboarding/onboarding_step2_clan_owner_filled.png",
      level: 2,
      parentId: 4,
      description: "Enter your clan's name.",
    },
    {
      title: "Clan: Member",
      image: "/assets/guide/auth/onboarding/onboarding_step2_clan_member.png",
      level: 1,
      parentId: 4,
      description: "Choose this if you have been invited to an existing clan.",
    },
    {
      title: "Clan: Guest",
      image: "/assets/guide/auth/onboarding/onboarding_step2_clan_guest.png",
      level: 1,
      parentId: 4,
      description: "Join as a guest to stay informed.",
    },
    {
      title: "Ready to Play",
      image: "/assets/guide/auth/dashboard.png",
      level: 0,
      description: (
        <>
          You're all set! Your account is configured and ready to go. Click
          below to head to your dashboard and start spectating or playing games.
          <div style={{ marginTop: "20px" }}>
            <button
              className="cta-button"
              onClick={() => (window.location.href = "/dashboard")}
            >
              Go to Dashboard
            </button>
          </div>
        </>
      ),
    },
  ];

  useEffect(() => {
    const currentStep = steps[stepIndex];
    if (currentStep.parentId !== undefined) {
      setExpandedSections((prev) => ({
        ...prev,
        [currentStep.parentId]: true,
      }));
    }
  }, [stepIndex]);

  const isParent = (stepId) => steps.some((s) => s.parentId === stepId);
  const toggleSection = (id) =>
    setExpandedSections((prev) => ({ ...prev, [id]: !prev[id] }));
  const currentStep = steps[stepIndex];

  return (
    <div className="guide-layout">
      <nav className="sub-nav">
        {steps.map((step, idx) => {
          const stepId = step.id || idx;
          const isNodeParent = isParent(stepId);
          const isVisible = step.level === 0 || expandedSections[step.parentId];

          return (
            <div
              key={idx}
              className={`nav-item-wrapper ${stepIndex === idx ? "active" : ""}`}
              style={{
                maxHeight: isVisible ? "60px" : "0px",
                opacity: isVisible ? 1 : 0,
              }}
            >
              <span
                className={`sub-nav-item level-${step.level}`}
                onClick={() => {
                  if (isNodeParent) toggleSection(stepId);
                  setStepIndex(idx);
                }}
              >
                {isNodeParent && (
                  <span style={{ marginRight: "8px", display: "flex" }}>
                    {expandedSections[stepId] ? (
                      <ChevronDown size={16} />
                    ) : (
                      <ChevronRight size={16} />
                    )}
                  </span>
                )}
                {step.title}
              </span>
            </div>
          );
        })}
      </nav>

      <main className="guide-main">
        <div className="guide-item">
          <div className="guide-text">
            <h2>{currentStep.title}</h2>
            <div className="nav-controls">
              <button
                disabled={stepIndex === 0}
                onClick={() => setStepIndex(stepIndex - 1)}
              >
                Back
              </button>
              <button
                disabled={stepIndex === steps.length - 1}
                onClick={() => setStepIndex(stepIndex + 1)}
                style={{ marginLeft: "10px" }}
              >
                {stepIndex === steps.length - 1 ? "Finish" : "Next"}
              </button>
            </div>
            <p className="step-counter">
              Step {stepIndex + 1} of {steps.length}
            </p>
            <div className="guide-text-wrapper">
              <div className="step-description">{currentStep.description}</div>
            </div>
          </div>
          <div className="screenshot-container">
            <img src={currentStep.image} alt={currentStep.title} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default OnboardingSection;
